module.exports = __webpack_public_path__ + "img/idc_pic03.022bdada.png";